import React from "react";
import PropTypes from "prop-types";

import ClientCard from "../components/client-card";
import styled from "styled-components";
import { _ } from "../utils/i18n";

const Wrapper = styled.div`
  padding: 0px 40px 20px 40px;
  margin: 0 0 60px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 810px) {
    padding: 0;
  }
`;
const BgGrey = styled.div`
  background-color: #f7f7f7;
  width: 100%;
  max-width: 1770px;
`;
const ClientContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @media (max-width: 1024px) {
    justify-content: center;
    flex-wrap: nowrap;
    overflow-y: scroll;
    justify-content: flex-start;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
const HeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  &:hover div {
    width: 150px;
  }
`;
const Title = styled.h3`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: 300;
  color: #08052c;
  margin-bottom: 10px;
  pointer-events: none;
`;
const Underline = styled.div`
  border-bottom: 1px solid #333;
  transition: 0.3s ease-in-out;
  width: 0;
`;

const LogoFeed = ({ categories }) => {
  return (
    <Wrapper>
      <BgGrey>
        <HeadlineContainer>
          <Title>{_("Kunder vi jobber med")}</Title>
          <Underline />
        </HeadlineContainer>
        <ClientContainer>
          {categories?.map((node, i) => (
            <ClientCard
              key={i}
              logoUrl={node.acfCategoryThumbnail.img?.sourceUrl}
            />
          ))}
        </ClientContainer>
      </BgGrey>
    </Wrapper>
  );
};

LogoFeed.propTypes = {
  categories: PropTypes.array,
};

LogoFeed.defaultProps = {
  categories: undefined,
};

export default LogoFeed;
